import React, { FC } from 'react'

import { IconControlPanelProps } from './IconControlPanel.types'
import * as Styled from './styles/IconControlPanel.style'

import { nonThemeableRules } from '../../ruleSet'

const IconControlPanel: FC<IconControlPanelProps> = ({
  size = nonThemeableRules.defaultSize as number as IconControlPanelProps['size'],
  isResponsive = false,
}: IconControlPanelProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M34 15v-2m0 22V19.983m-10-3.92V13m0 22v-9.64m-10 6.37V35m0-22v13.063'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M10.973 7.035h30.055V37.09a4 4 0 0 1-4 4H10.973a4 4 0 0 1-4-4V11.035a4 4 0 0 1 4-4v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M14 31.492a2.493 2.493 0 1 0 0-4.985 2.493 2.493 0 0 0 0 4.985Zm9.937-6.132a2.492 2.492 0 1 0 0-4.985 2.492 2.492 0 0 0 0 4.985ZM34 19.985A2.492 2.492 0 1 0 34 15a2.492 2.492 0 0 0 0 4.985Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconControlPanel
